// 设备共享
export default {
    username: 'имя пользователя',
    remarks: 'Замечания',
    PN: 'телефонный номер',
    ASU: 'Добавить общих пользователей',
    SD: 'Общее оборудование',
    VD: 'Эксклюзивное оборудование',
    DN: 'Название оборудования',
    CV: 'Текущий эксклюзив',
    FS: 'Статус полета',
    IF: 'В полете',
    NF: 'Не летают',
    deviceshar: 'совместное использование устройства',
    dev: 'оборудование',
    Shareuser: 'Поделиться пользователем',
    pinputshareuser: 'Пожалуйста, введите общего пользователя',
    addsharedev: 'добавить разработчика',
    owner: 'владелец',
    Exclusiveuser: 'Эксклюзивный пользователь',
    cancelshare: 'Отменить публикацию',
    exitshare: 'Выйти из общего доступа',
    setexclusive: 'Настроить эксклюзивный',
    cancelexclusive: 'Отменить эксклюзив',
    getexclusive: 'Получите эксклюзив',
    selsharedev: 'Выберите общее устройство',
    mobile: 'Мобильный телефон',
    flymodel: 'Тип самолета',
    next: 'Следующий шаг',
    selectsharduser: 'Выберите общего пользователя',
    user: 'номер счета',
    userno: 'Пользователь не существует или не зарегистрирован',
    add: 'Добавить',
    historyuser: 'Пользователь с обменом историей',
    clearhistory: 'Очистить исторические сообщения',
    editsharedev: 'Изменить общее устройство',
    sharenum: 'Количество акций',
    manycancel: 'Отмена партии',
    setexclusiveuser: 'Настроить выделенных пользователей',
    pselectdev: 'Пожалуйста, сначала выберите устройство, которым хотите поделиться',
    pselectshareuser: 'Пожалуйста, выберите пользователя, чтобы поделиться',
    pselectexcuser: 'Пожалуйста, сначала выберите пользователя, который будет эксклюзивным',
    cancelcdevshare: 'Эта операция отменит совместное использование этого устройства, продолжать ли',
    cancelchedevshare: 'Эта операция снимет отметку с общего доступа к устройству, продолжать ли',
    cancelexitshare: 'Эта операция закрывает общий доступ к устройству, продолжать ли',
    exited: 'Отменен выход',
    canceled: 'Отменено',
    onlysetshareuser: 'Может быть установлен только один выделенный пользователь',
    tip_del: 'После удаления пользователя он не сможет совместно использовать эксклюзивные устройства. Удалить его или нет ?',
    tip_MODID: 'Значение элемента данных: имя устройства (текущий эксклюзивный пользователь)',
    tip_PEDN: 'Пожалуйста, введите имя устройства',
    tip_MODID1: 'Значение элемента данных: имя устройства (текущий эксклюзивный пользователь), не может быть проверено во время полета',
}